var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReminder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 33.229V38.6a2.686 2.686 0 0 0 2.686 2.686h32.228A2.686 2.686 0 0 0 42.6 38.6V33.23H5z",
    fill: "#B5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.736 33.229V38.6a2.686 2.686 0 0 1-2.686 2.686h1.864A2.686 2.686 0 0 0 42.6 38.6V33.23h-1.864z",
    fill: "#97D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11.743v24.171A2.686 2.686 0 0 0 7.686 38.6h32.228a2.686 2.686 0 0 0 2.686-2.686V11.743H5z",
    fill: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.736 11.743v24.171A2.686 2.686 0 0 1 38.05 38.6h1.864a2.686 2.686 0 0 0 2.686-2.686V11.743h-1.864z",
    fill: "#D5E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6 13.086V6.37a2.686 2.686 0 0 0-2.686-2.685H7.686A2.686 2.686 0 0 0 5 6.37v6.715h37.6z",
    fill: "#0076FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.057 6.98h-1.343a.608.608 0 0 1 0-1.216h1.343a.608.608 0 0 1 0 1.215zM17.086 6.98h-1.343a.608.608 0 0 1 0-1.216h1.343a.608.608 0 0 1 0 1.215zM31.857 6.98h-1.343a.608.608 0 0 1 0-1.216h1.343a.608.608 0 0 1 0 1.215zM35.886 6.98h-1.343a.608.608 0 0 1 0-1.216h1.343a.608.608 0 0 1 0 1.215z",
    fill: "#0062D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.057 6.371a1.343 1.343 0 0 0 2.686 0V2.343a1.343 1.343 0 0 0-2.686 0V6.37zM31.857 6.371a1.343 1.343 0 0 0 2.686 0V2.343a1.343 1.343 0 1 0-2.686 0V6.37z",
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0062D4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.914 3.686H38.05a2.686 2.686 0 0 1 2.686 2.685v6.715H42.6V6.37a2.686 2.686 0 0 0-2.686-2.685z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9.792h37.6v1.216H5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.843 30.543H17.757c-.37 0-.671-.3-.671-.671v-1.698c0-.208.048-.414.141-.6l1.06-2.119c.093-.186.142-.392.142-.6v-2.37a5.371 5.371 0 0 1 10.743 0v2.37c0 .208.048.413.141.6l1.06 2.119c.093.186.141.392.141.6v1.698c0 .37-.3.67-.671.67z",
    fill: "#FBD64D"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.086 17.114)",
    fill: "#FDBF00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.287 10.46-1.06-2.12a1.343 1.343 0 0 1-.141-.6V5.371A5.371 5.371 0 0 0 5.782.082a5.372 5.372 0 0 1 4.44 5.29V7.74c0 .209.048.414.141.6l1.06 2.12c.093.186.141.392.141.6v1.697c0 .371-.3.672-.671.672h1.864c.371 0 .672-.3.672-.672V11.06c0-.208-.049-.414-.142-.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-80.792 6.708 15.439)",
    cx: 6.708,
    cy: 15.439,
    r: 2.014
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.142 10.46a1.343 1.343 0 0 0-.142.6v.29h13.429v-.29c0-.208-.049-.414-.142-.6l-.162-.325H.304l-.162.324z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.064e210353326e9f4a5cbb682b8bb402.svg";
export { ForwardRef as ReactComponent };